import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import changeQtyOrdered from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeQtyOrdered";
import updateVariantSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    variantTraits: getProductState(state, ownProps.parentProductId).value?.variantTraits,
});

const mapDispatchToProps = {
    updateVariantSelection,
    changeQtyOrdered,
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    height: 100%;
    width: 100%;
`;

const ProductDetailsClearForm = ({
    fields,
    variantTraits,
    parentProductId,
    updateVariantSelection,
    changeQtyOrdered,
    productContext: {
        product: { id: productId },
    },
}: Props) => {
    const [isLoaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        setLoaded(true);
    }, []);

    const clearTraitsSelectionClick = () => {
        variantTraits?.forEach(trait => {
            updateVariantSelection({ variantTraitId: trait.id, traitValueId: "", productId: parentProductId });
        });
        if (productId && parentProductId) {
            changeQtyOrdered({ productId, qtyOrdered: 1 });
            changeQtyOrdered({ productId: parentProductId, qtyOrdered: 1 })
        }
    };

    if (typeof window !== "undefined") {
        return (
            <Wrapper>
                <Clickable
                    css={css`
                        font-size: 15px;
                        color: ${getColor("primary")};
                    `}
                    onClick={clearTraitsSelectionClick}
                >
                    {fields.text || "Clear Form"}
                </Clickable>
            </Wrapper>
        );
    }
    return null;
};

const widgetModule: WidgetModule = {
    component: withProductContext(withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsClearForm))),
    definition: {
        displayName: "Product Details Clear Form",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: "text",
                displayName: "Text",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
